module.exports = __webpack_public_path__ + "img/mass-production-1.2884c070.png";